<template>
  <div v-loading="loading">
    <el-row>
      <el-row style="min-height: calc(100vh - 300px)">
        <br />
        <el-col :span="24">
          <el-form :inline="true">
            <el-form-item label="股票选择">
              <el-select @focus="showSearchLogs" :popper-append-to-body="false" @change="getSearchLogs"
                v-model="stockCode" value-key="ts_code" filterable remote :remote-method="searchStock"
                default-first-option placeholder="请输入股票名称或股票代码">
                <el-option-group :label="searchLabel">
                  <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.symbol">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="quickGenPdf(stockCode, '普通搜索')">分析一下</el-button>
            </el-form-item>

          </el-form>
        </el-col>

      </el-row>

    </el-row>

    <!--类型选择框-->
    <el-dialog width="600px" :visible.sync="typeDialogVisible">
      <div class="c_p" slot="title">
        <b>{{ stockName || '个股分析' }}</b>
      </div>
      <el-row>
        智能财经报告分析平台已识别到目标公司的以下属性，并将据此自动调整
        <span class="c_p">报告内容</span> <br /><br />
      </el-row>
      <el-row v-if="stockStates === 'PT' || stockStates === 'D' || stockStates === 'WD'
    ">
        <span class="c_p">
          该股票存在数据缺失，可能影响报告效果，请确认是否继续生成？</span>
        <br /><br />
      </el-row>
      <el-row>
        <el-col :span="3">
          所属板块
        </el-col>
        <el-col :span="5">
          <el-tag type="warning"> {{ stockTags.block || '无' }}</el-tag>
          <br />
        </el-col>
        <el-col :span="3">
          上市状态
        </el-col>
        <el-col :span="13">
          <template v-for="(item, index) in stockStates">
            <el-tag type="danger" :key="index">{{
    item.list_status | stockStatusFilter
  }}</el-tag>
          </template>
        </el-col>
        <el-row>
          &nbsp;
        </el-row>
        <el-col :span="3">
          申万行业
        </el-col>
        <el-col :span="5">
          <el-tag> {{ stockTags.industry || '无' }}</el-tag>
        </el-col>
        <el-col :span="3">
          所属概念
        </el-col>
        <el-col :span="13">
          <template v-if="stockTags && stockTags.concepts && stockTags.concepts.length > 0
    ">
            <template v-for="(item, index) in stockTags.concepts">
              <el-tag v-if="index < 3" :key="index" type="success">
                {{ item }}</el-tag>&nbsp;
            </template>
          </template>
          <template v-else>
            <el-tag type="success"> 无</el-tag>
          </template>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-form>
        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="fileType" label="PDF">PDF</el-radio>
            <el-radio v-model="fileType" label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="选择日期">
          <el-select v-model="selectYear" placeholder="请选择">
            <el-option v-for="(item, index) in tradeDates" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <span>请注意，选择【生成】即扣除报告下载次数,<br />
          若当前账户内没有剩余下载次数，可以购买单篇报告，<br />或者点击右上角【会员套餐】购买超值套餐<br />目前系统支持生成近【2年】内的年报解析报告</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="genPdf">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500" top="0" :close-on-click-modal="false" :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl + '#toolbar=0'" style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf()" size="small">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import pay from '../pay'
import moment from 'moment'
export default {
  name: 'stock',
  data: function () {
    let _this = this
    return {
      curStock: {},
      stockCode: '',
      stockName: '',
      searchStock0001: {},
      searchLabel: '搜索结果',
      reportType: 'YEAR',
      fileType: 'PDF',
      options: [],
      candidateOptions: [],
      pdfUrl: '',
      loading: false,

      growth_type: 'growth_year',
      pdfDialogVisible: false,
      tabsName: 'finance',
      openDate: '',
      openHtml: '',
      closeDate: '',
      closeHtml: '',
      curSourceId: '',
      typeDialogVisible: false,
      selectDialogVisible: false,
      selectForm: {},
      searchLogs: [],
      searchStocks: [],
      reportId: '',

      selectYear: '',
      stockStates: [],
      stockTags: [],
      tradeDates: [
        { label: "2023-12-31", value: "2023-12-31" }
      ],
      pickerOptions: {
        disabledDate (time) {
          let dateStr = moment(time).format('YYYY-MM-DD')
          return _this.tradeDates.indexOf(dateStr) === -1
        }
      }
    }
  },

  components: {
    pay
  },

  watch: {
    payResult: function () {
      this.reportId = this.$store.state.payData.id
      if (this.reportId) {
        this.getReportStatus()
      }
    }
  },

  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },
    stockStatusFilter: function (v) {
      switch (v) {
        case 'N':
          return '新股'
        case 'SN':
          return '次新股'
        case 'PT':
          return '等待退市'
        case 'D':
          return '退市'
        case 'WD':
          return '退市整理'
        case 'L':
          return '正常'
        default:
          return v
      }
    }
  },
  computed: {
    payResult: function () {
      return this.$store.state.payResult
    },
    userInfo: function () {
      let temp = localStorage.getItem('userinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return null
    },
    accountinfo: function () {
      let temp = localStorage.getItem('accountinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return {}
    }
  },
  methods: {
    quickGenPdf (symbol, source) {
      if (source) {
        // eslint-disable-next-line no-undef
        _hmt.push(['_trackEvent', '生成个股报告来源', source])
      }
      this.stockCode = symbol
      this.options = this.candidateOptions
      if (!this.stockCode) {
        this.$message.error('请选择股票')
        return
      }
      if (this.stockCode.indexOf('.') > -1) {
        let tsCodeArray = this.stockCode.split('.')
        this.stockCode = (tsCodeArray[1] + tsCodeArray[0]).toLowerCase()
      }
      let _this = this
      this.candidateOptions.forEach(i => {
        if (i.ts_code.indexOf(symbol) > -1) {
          _this.stockName = i.name
        }
      })

      axios
        .get(
          `/api/web/stock/checkStock/${this.reportType}/${this.stockCode}`
        )
        .then(resp => {
          _this.stockStates = resp.data
        })
      axios.get('/api/web/stock/stockLabel/' + this.stockCode).then(resp => {
        _this.stockTags = resp.data
      })
      axios.get('/api/web/report/financeYear/' + this.stockCode).then(resp => {
        debugger
        _this.tradeDates = resp.data
        _this.selectYear = _this.tradeDates[0].value
      })
      this.typeDialogVisible = true
    },

    genPdf () {
      this.typeDialogVisible = false
      let _this = this
      this.loading = true
      axios
        .get(
          `/api/web/report/genReport/${this.fileType}/${this.reportType}/${this.stockCode}?date=${this.selectYear}`
        )
        .then(resp => {
          _this.pdfUrl = ''
          _this.reportId = resp.data.id
          _this.$store.commit('toFreshUserPrice')
          _this.getReportStatus()
        })
        .catch(e => {
          _this.loading = false
          if (e.code === 401) {
            _this.$alert(e.msg, '您的使用次数已超过限制!')
          }
        })
    },

    getReportStatus () {
      let _this = this
      axios.get('/api/web/stock/reportInfo/' + _this.reportId).then(resp => {
        _this.loading = true
        if (resp.data.status === 'DOING') {
          _this.loading = true
          setTimeout(() => {
            _this.getReportStatus(_this.reportId)
          }, 2000)
        } else if (resp.data.status === 'FINISH') {
          _this.loading = false
          _this.sourceId = resp.data.sourceId
          if (resp.data.fileType === 'PDF') {
            _this.pdfDialogVisible = true
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        } else {
          _this.loading = false
          _this.$notify.error({
            title: '失败',
            message: '报告生成失败，请稍候重试。'
          })
        }
      })
    },

    showSearchLogs () {
      this.searchLabel = '搜索历史'
      this.options = this.searchLogs
    },
    searchStock (query) {
      this.searchLabel = '搜索结果'
      query = query.trim()
      if (query) {
        let _this = this
        setTimeout(() => {
          _this.options = _this.candidateOptions.filter(item => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              (item.pinyin || '').toLowerCase().indexOf(query.toLowerCase()) >
              -1
            )
          })
        }, 200)
      } else {
        this.options = this.searchLogs
      }
    },


    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    },

    getSearchLogs (item) {
      this.searchLabel = '搜索历史'
      let url = '/api/web/stock/searchLogs'
      if (item) {
        url = url + '?code=' + item
      }
      let _this = this
      axios.get(url).then(resp => {
        _this.searchLogs = resp.data
      })
    },

  },

  mounted () {
    let _this = this
    try {
      this.candidateOptions = JSON.parse(
        localStorage.getItem('candidateOptions')
      )
    } catch (e) { }
    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data
      localStorage.setItem(
        'candidateOptions',
        JSON.stringify(_this.candidateOptions)
      )
      _this.loading = false
    })

    this.getSearchLogs()

  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}

.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}

.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}

.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/year.vue